// Central API base and route helpers for the widget

// Robust API base resolution with multiple fallback methods
const getApiBase = () => {
  // For local development, always use port 8000 (matches backend default)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000';
    }
  }
  
  // Production - prefer env var, fallback to Render deployment
  return process.env.REACT_APP_API_BASE_URL || 'https://opsvoice-rag-api.onrender.com';
};

const API_BASE = getApiBase().replace(/\/$/, '');

// ---------------------------------------------------------------------------
// Widget public key (publishable, client-side credential)
//
// The widget bootstraps from /widget/config, which now returns the company's
// widget_public_key. We hold it module-side so the protected routes (coach-tools,
// metrics, activity, subscription/info, feedback) can attach it as the
// X-Widget-Public-Key header. The backend's tenant_resolver.extract_widget_public_key
// reads exactly that header (and verifies the key resolves to the same company as
// the requested slug). This is publishable by design, like a Stripe publishable key,
// and is NOT the secret service_role key. The header is additive: when no key is set,
// widgetKeyHeaders() returns {} and the existing slug-based behavior is unchanged.
// ---------------------------------------------------------------------------
let _widgetPublicKey = null;

export const setWidgetPublicKey = (key) => {
  _widgetPublicKey = (typeof key === 'string' && key.trim()) ? key.trim() : null;
};

export const getWidgetPublicKey = () => _widgetPublicKey;

// Returns the widget-key header when a key is present, otherwise an empty object.
// Spread into any fetch headers, e.g. headers: { ...widgetKeyHeaders(), ... }.
export const widgetKeyHeaders = () => (
  _widgetPublicKey ? { 'X-Widget-Public-Key': _widgetPublicKey } : {}
);

export const api = {
  // Config is served from the root (no /api/v1)
  config: () => `${API_BASE}/widget/config`,
  // Core endpoints
  query: () => `${API_BASE}/api/v1/query`,
  metrics: () => `${API_BASE}/api/v1/metrics`,
  vapiFunction: () => `${API_BASE}/api/v1/vapi-function`,
  activity: (slug) => `${API_BASE}/api/v1/activity/${slug}`,
  companyDocs: (slug) => `${API_BASE}/api/v1/company-docs/${slug}`,
  voiceReply: () => `${API_BASE}/api/v1/voice-reply`,
  coachTools: (slug, params) => {
    const search = params ? `?${params}` : '';
    return `${API_BASE}/api/v1/coach-tools/${slug}${search}`;
  },
  markFrameworkTool: (docId) => `${API_BASE}/api/v1/documents/${encodeURIComponent(docId)}/mark-as-tool`,
};

export { API_BASE };


